// Module
var code = `<div appHeaderBar>
    <header-bar-title>Create a new profile</header-bar-title>
</div>

<app-page-content [showWebFooter]="true" [usePagePadding]="true">
    <app-alert-banner *ngIf="created" type="success" title="Account Created Successfully"></app-alert-banner>
    <app-alert-banner *ngIf="failed" type="error" title="We couldn't create your profile">
        Something went wrong. Please try again later.
    </app-alert-banner>

    <form [formGroup]="form" (ngSubmit)="submit()">
        <div class="HOA-container">
            <div class="HOA-container__header">
                <div class="create-sso-profile__heading">
                    <div class="HOA-container__header-text">Create a new profile</div>
                    <div class="create-sso-profile__hint">
                        (<span class="create-sso-profile__req">*</span>) indicates a required field
                    </div>
                </div>
            </div>

            <div class="HOA-container__content">
                <div class="HOA-flextable-component HOA-flextable-component__form">
                    <div
                            class="Field HOA-flextable-component__cell--50-ifSizeIsLargerThanPhone
                            HOA-flextable-component__cell--100-field HOA-flextable-component__cell-field"
                            [class.is-invalid]="showError('firstName')"
                    >
                        <label for="firstName" class="Field-label">
                            First Name
                            <span class="asterisk-required">&nbsp;&#42;</span>
                        </label>
                        <input
                                type="text"
                                class="Input"
                                id="firstName"
                                name="firstName"
                                maxlength="25"
                                formControlName="firstName"
                                [attr.aria-invalid]="showError('firstName')"
                                [attr.aria-describedby]="showError('firstName') ? 'firstName-error' : null"
                        />
                        <span class="Field-error" id="firstName-error">Please enter your first name.</span>
                    </div>

                    <div
                            class="Field HOA-flextable-component__cell--50-ifSizeIsLargerThanPhone
                            HOA-flextable-component__cell--100-field HOA-flextable-component__cell-field"
                            [class.is-invalid]="showError('lastName')"
                    >
                        <label for="lastName" class="Field-label">
                            Last Name
                            <span class="asterisk-required">&nbsp;&#42;</span>
                        </label>
                        <input
                                type="text"
                                class="Input"
                                id="lastName"
                                name="lastName"
                                maxlength="35"
                                formControlName="lastName"
                                [attr.aria-invalid]="showError('lastName')"
                                [attr.aria-describedby]="showError('lastName') ? 'lastName-error' : null"
                        />
                        <span class="Field-error" id="lastName-error">Please enter your last name.</span>
                    </div>

                    <div
                            class="Field HOA-flextable-component__cell--50-ifSizeIsLargerThanPhone
                            HOA-flextable-component__cell--100-field HOA-flextable-component__cell-field"
                            [class.is-invalid]="showError('phone')"
                    >
                        <label for="input-text-phone-number" class="Field-label">
                            Phone Number
                            <span class="asterisk-required">&nbsp;&#42;</span>
                        </label>
                        <!--Country dropdown + joined phone input (was a single input) -->
                        <div class="Field-addonBox">
                            <div class="Field-addon HOA-Field-addon HOA-Field-phone-select Select">
                                <label for="countryCodeInput" class="hide">Country Code</label>
                                <select
                                        id="countryCodeInput"
                                        tid="countryCodeInput"
                                        formControlName="countryCode"
                                        (change)="onCountryChange()"
                                >
                                    <option *ngFor="let code of countryCodes" [ngValue]="code">
                                        {{ code.country + ' (+' + code.value + ')' }}
                                    </option>
                                </select>
                                <span class="Select-arrow"></span>
                            </div>
                            <input
                                    type="text"
                                    class="Input HOA-Field-phone-input"
                                    id="input-text-phone-number"
                                    tid="phoneNumberInput"
                                    formControlName="phone"
                                    (input)="onPhoneInput()"
                                    (blur)="onPhoneInput()"
                                    autocapitalize="off"
                                    autocomplete="off"
                                    autocorrect="off"
                                    spellcheck="false"
                                    [attr.aria-invalid]="showError('phone')"
                                    [attr.aria-describedby]="showError('phone') ? 'phoneNumber-error' : null"
                            />
                        </div>
                        <span class="Field-error" id="phoneNumber-error">Please enter a valid 10-digit phone number.</span>
                    </div>

                    <div
                            class="Field HOA-flextable-component__cell--50-ifSizeIsLargerThanPhone
                            HOA-flextable-component__cell--100-field HOA-flextable-component__cell-field"
                    >
                        <label for="emailaddress" class="Field-label">
                            Email
                            <span class="asterisk-required">&nbsp;&#42;</span>
                        </label>
                        <input
                                type="email"
                                class="Input"
                                id="emailaddress"
                                formControlName="email"
                        />
                    </div>
                </div>

                <div class="create-sso-profile__actions u-mT6">
                    <button class="HOA-splash-buttons-container__button Button Button--blue" type="submit"
                            [disabled]="!form.valid || submitting">Create Profile</button>
                    <button *ngIf="!submitting" class="HOA-splash-buttons-container__button Button Button--outline" type="button"
                            (click)="goBack()">Go Back</button>
                </div>
            </div>
        </div>
    </form>
</app-page-content>`;
// Exports
module.exports = code;